import { Breadcrumbs } from "./Breadcrums";
import PageTitle from "./PageTitle";

interface Props {
  title: string;
  list: any;
}

export default function Header({title, list}: Props) {
  return (
    <div className="border rounded-md my-3 p-4">
      <PageTitle title={title}/>
      <Breadcrumbs list={list}/>
    </div>
  )
}
